// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falCirclePlay: CreateIconOptions = {
  "displayName": "FALCirclePlay",
  "viewBox": "0, 0, 512, 512",
  "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7l0-147.5L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"
};
